/**
 * UI state machine for the push-to-talk interaction, derived in `WebRTCPlayer`
 * from the raw transport `WebRTCTalkSignal`s (see `./webrtc-events`) plus user
 * intent and confirmation timing:
 * - `UNAVAILABLE` — talkback not usable (no channel yet / torn down). UI-only.
 * - `READY`       — channel open and idle; the user can claim talkback.
 * - `REQUESTING`  — user requested a change; awaiting camera confirmation. UI-only.
 * - `GRANTED`     — camera granted the claim; mic is live.
 * - `CLOSED`      — channel closed after being open; talkback unavailable.
 */
export enum PttUiState {
	UNAVAILABLE = 'unavailable',
	READY = 'ready',
	REQUESTING = 'requesting',
	GRANTED = 'granted',
	CLOSED = 'closed',
}
